import HowToHeader from '../HowToHeader';

// Images
import img1 from './Image 1.png';

// Header
const headerText = `Modifying Intermediary/Room Selections`;
const subtitleText = `If you want to add/remove an intermediary platform or room that’s listed in your unit, click on the reference number or registration number from the Account Dashboard. This will open up your application where you can modify your intermediary platform and/or your room selections. After the desired changes are made, click “Save Changes”`;

const ModifyingIntermediaryRoomSelections = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <div className='text-center'>
        <img className='img-fluid' src={img1} alt='Image 5' />
      </div>
    </>
  );
};

export default ModifyingIntermediaryRoomSelections;
